import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'light' } = { theme: 'light' }

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className='toaster group'
      toastOptions={{
        classNames: {
          toast:
            'group toast group-[.toaster]:bg-white-200 group-[.toaster]:text-black-200 group-[.toaster]:border group-[.toaster]:border-grey-300 group-[.toaster]:shadow-md-down  p-2.5',
          error:
            'group-[.toaster]:!bg-red-100 group-[.toaster]:text-red-300 group-[.toaster]:!border-red-200',
          description: 'group-[.toast]:text-black-200',
          success:
            'group-[.toaster]:!bg-green-100 group-[.toaster]:text-green-300 group-[.toaster]:!border-green-200',
          warning:
            'group-[.toaster]:!bg-yellow-100 group-[.toaster]:text-yellow-300 group-[.toaster]:!border-yellow-200',
          info: 'group-[.toaster]:!bg-blue-100 group-[.toaster]:text-blue-300 group-[.toaster]:!border-blue-200',
          actionButton: 'group-[.toasr]:bg-black-200 group-[.toast]:text-white-100',
          cancelButton: 'group-[.toast]:bg-white-200 group-[.toast]:text-grey-300'
        }
      }}
      {...props}
    />
  )
}

export { Toaster }
